import React from "react";
import "./Bio.css";
import useInView from "../hooks/useInView";

function Bio() {
	const [myRef, visible] = useInView();

	return (
		<div className="bio" id="bio">
			<div className="bio_container">
				<p className="shimmer bio_wrapper">bio</p>
				<div
					ref={myRef}
					className={`${visible ? "bio_reveal" : "bio_reveal_inactive"}`}
				>
					<div className="bio_content">
						<p className="bio_paragraph-wrapper">
							Growing up on a farm, I learned the value of perseverance and hard
							work — and I've carried that mindset into every line of code I've
							written since teaching myself to program.
							<br />
							<br />
							I'm a Shopify developer focused on building high-performing
							eCommerce experiences. I work with Liquid, the Storefront API, the
							Admin API, and GraphQL to craft fast, conversion-optimized
							storefronts — and I've shipped a published app to the Shopify App
							Store.
							<br />
							<br />
							On the frontend I build with React and Next.js, and I care deeply
							about clean UI, responsive design, and experiences that just work.
						</p>
						<div className="face_pic">
							<div className="pic_parent">
								<img
									className="pic_child"
									src="images/facepic2.jpeg"
									alt="Wyatt Chamberlin"
									id="img"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Bio;
